export const GET_CON_CAPACITY_ALL = 'GET_CON_CAPACITY_ALL';
export const SET_CONSUMER_DETAILS = 'SET_CONSUMER_DETAILS';
export const SET_ENERGY_TYPE_DETAILS = 'SET_ENERGY_TYPE_DETAILS';
export const GET_CON_CAPACITY_EDIT_HISTORY = 'GET_CON_CAPACITY_EDIT_HISTORY';
export const RESET_CON_CAPACITY = 'RESET_CON_CAPACITY'



